import en from "@/localization/en.json";
import { PropTypes } from "prop-types";

function TextAreaInputField({
  labelName,
  isFieldRequired = false,
  className = "h-[11rem]",
  placeholder = en["common.enter_text"],
  name,
  register,
  error,
  ...textAreaProps
}) {
  const getBorderColor = () => {
    if (error?.message) {
      return "border-[#FF4249] focus:border-[#FF4249]";
    } else {
      return "border-[#CBD0D6] focus:border-[#414E5F]";
    }
  };

  return (
    <div>
      <p className="text-grayD2 mb-[.875rem] md:mb-[1rem]">
        {labelName}
        {isFieldRequired && <span className="text-[#E81E61]">*</span>}
      </p>
      <textarea
        className={` border-1 focus:outline-none focus:border-[#CBD0D6] focus:ring-0  outline-0 ${getBorderColor()} rounded-[10px] w-full text-[1rem] p-[1.125rem] resize-none ${className}`}
        placeholder={placeholder}
        {...register(name)}
        {...textAreaProps}
      ></textarea>

      {error?.message && (
        <p className="text-[#FF4242] text-[0.875] mt-[0.35rem] first-letter:uppercase">
          {error?.message}
        </p>
      )}
    </div>
  );
}

TextAreaInputField.propTypes = {
  labelName: PropTypes.string,
  isFieldRequired: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  register: PropTypes.func,
  error: PropTypes.string,
};

export default TextAreaInputField;
